export default "__VITE_ASSET__DWaWGWCv__"